import { useEffect, useMemo } from 'react';
import { useQuery, useReactiveVar } from '@apollo/client';
import { useNavigate } from 'react-router-dom';

import { Appointment } from '../appointment';
import { PrimaryBanner } from '../primary-banner';
import { MyBonusesLensesSection } from '../my-bonuses-lenses-section';
import { Promotions } from '../promotions';
import { MyOrders } from '../my-orders';
import { VisionProfile } from '../vision-profile';
import { EcpLocator } from '../ecp-locator';
// import { Wiki } from '../wiki';
import { useStyles } from './landing-page-logged-in.styles';
import { OrderModal } from '../order-modal';
import { GET_FITTED_LENSES } from '../../../../../graphql/lenses/queries/get-fitted-lenses';
import { IFittedLenses } from '../../../../../graphql/lenses/models/get-fitted-lenses.models';
import { isUserFitted } from '../../../../../utils/lenses/is-user-fitted';
import {
  setC2CMode,
} from '../../../../../graphql/configuration/configuration.cache';
import { C2CMode } from '../../../../common/configuration-settings/configuration-settings.models';
import { Simulator } from '../simulator';
import { KidsBanner } from '../kids-banner';
import { v2025PP16783 } from '../../../../../constants/veeva';
import { Veeva } from '../../../../common/veeva';
import { useGoBack } from '../../../../../hooks/use-go-back';
import { useIdAnalytics } from './hooks/use-id-analytics';
import { CvBanner } from '../../user-activity-items';

export const LandingPageLoggedIn = (): JSX.Element => {
  const { data, loading } = useQuery<IFittedLenses>(GET_FITTED_LENSES);
  const isFittedUser = useMemo(() => {
    return isUserFitted(data);
  }, [data, isUserFitted]);
  const classes = useStyles();
  const c2CMode = useReactiveVar(setC2CMode);
  const navigate = useNavigate();
  const { hasPreviousLocationState } = useGoBack();
  const onNavigate = (url: string): void => {
    navigate(url, { state: hasPreviousLocationState });
  };
  const { pushId } = useIdAnalytics();

  useEffect((): void => {
    pushId();
  }, [pushId]);

  return (
    <>
      <Appointment />
      <PrimaryBanner />
      <div className={classes.coloredSection}>
        <MyBonusesLensesSection />
        <CvBanner />
        <KidsBanner />
        <Promotions />
        {!loading && (
          <MyOrders
            isFitted={isFittedUser}
            c2CMode={c2CMode}
          />
        )}
        <div className={classes.simulator}>
          <Simulator />
        </div>
        <VisionProfile />
      </div>
      <EcpLocator isLoggedIn={true} />
      { /* <div className={classes.wikiWrapper}> */ }
      { /*  <Wiki /> */ }
      { /* </div> */ }
      {(!loading && c2CMode === C2CMode.full) && <OrderModal isFitted={isFittedUser} onNavigate={onNavigate} />}
      <Veeva veevaNumber={v2025PP16783} isRight></Veeva>
    </>
  );
};
